import { appSlice } from '../store/slice';

export const { setIsAppInitialized, setErrorHandler, showError } = appSlice.actions;
